<template>
  <div style="overflow-wrap: anywhere;">
    <h5>
      Health Data Sources
    </h5>

    <ol>
      <li>U.S. Department of Agriculture and U.S. Department of Health and Human Services. Dietary Guidelines for Americans, 2020-2025. 9th Edition. December 2020.</li>
      <li>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="http://www.kidneyfoundation.org"
        >
          The National Kidney Foundation
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="http://www.diabetes.org"
        >
          American Diabetes Association
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="http://www.aha.org"
        >
          American Heart Association
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://www.cdc.gov/physicalactivity/basics/adults/index.htm"
        >
          https://www.cdc.gov/physicalactivity/basics/adults/index.htm
        </a>
      </li>
    </ol>
  </div>
</template>

<script>
export default {}
</script>
